module.exports = __webpack_public_path__ + "img/flechaizquierda.74c7ca84.gif";